import "./PreorderInfoModal.css";
import bag from "../assets/bag.png";
import a1 from "../assets/1(2).png";
import a2 from "../assets/2(1).png";
import a3 from "../assets/3(1).png";
import a4 from "../assets/4(1).png";


/* ── Inline SVG illustrations ── */

const BagTimerIllustration = () => (
  <svg viewBox="0 0 110 130" xmlns="http://www.w3.org/2000/svg" className="pim-bag-svg">
    {/* Background circle */}
    <circle cx="52" cy="65" r="48" fill="#FDECEA" />
    {/* Paper bag body */}
    <rect x="22" y="38" width="44" height="52" rx="4" fill="#D4956A" />
    <rect x="22" y="38" width="44" height="10" rx="4" fill="#C07A50" />
    {/* Bag fold lines */}
    <line x1="30" y1="55" x2="58" y2="55" stroke="#B86E44" strokeWidth="1" opacity="0.5"/>
    <line x1="30" y1="63" x2="58" y2="63" stroke="#B86E44" strokeWidth="1" opacity="0.5"/>
    {/* Bag handle */}
    <path d="M32 38 Q32 28 44 28 Q56 28 56 38" fill="none" stroke="#C07A50" strokeWidth="3" strokeLinecap="round"/>
    {/* Bag icon/logo */}
    <circle cx="44" cy="68" r="10" fill="#C07A50" opacity="0.4"/>
    <path d="M39 68 Q44 62 49 68" fill="none" stroke="#fff" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="44" cy="72" r="2" fill="#fff" opacity="0.7"/>
    {/* Timer circle */}
    <circle cx="78" cy="95" r="22" fill="#fff" stroke="#E53E3E" strokeWidth="3"/>
    <circle cx="78" cy="95" r="18" fill="#fff"/>
    {/* Timer tick marks */}
    {[0,30,60,90,120,150,180,210,240,270,300,330].map((angle, i) => {
      const r1 = i % 3 === 0 ? 12 : 14;
      const r2 = 16;
      const rad = (angle - 90) * Math.PI / 180;
      return <line key={i}
        x1={78 + r1 * Math.cos(rad)} y1={95 + r1 * Math.sin(rad)}
        x2={78 + r2 * Math.cos(rad)} y2={95 + r2 * Math.sin(rad)}
        stroke="#E53E3E" strokeWidth={i % 3 === 0 ? 1.5 : 0.8} opacity="0.6"
      />;
    })}
    {/* Timer hands */}
    <line x1="78" y1="95" x2="78" y2="82" stroke="#E53E3E" strokeWidth="2" strokeLinecap="round"/>
    <line x1="78" y1="95" x2="88" y2="90" stroke="#333" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="78" cy="95" r="2" fill="#E53E3E"/>
    {/* "30 min" text */}
    <text x="78" y="100" textAnchor="middle" fontSize="7" fontWeight="800" fill="#E53E3E" fontFamily="Inter,sans-serif">30</text>
    <text x="78" y="107" textAnchor="middle" fontSize="5" fontWeight="600" fill="#E53E3E" fontFamily="Inter,sans-serif">min</text>
    {/* Timer top knob */}
    <rect x="75" y="74" width="6" height="3" rx="1.5" fill="#E53E3E"/>
  </svg>
);

const PhoneOrderIcon = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
    <rect width="48" height="48" rx="10" fill="#E8F5D4"/>
    <rect x="13" y="7" width="22" height="34" rx="3" fill="#2d4a0f"/>
    <rect x="15" y="11" width="18" height="24" rx="1" fill="#f0f9e4"/>
    <circle cx="24" cy="38" r="1.5" fill="#4a7c10"/>
    {/* Cart icon on screen */}
    <circle cx="20" cy="19" r="1" fill="#4a7c10"/>
    <circle cx="28" cy="19" r="1" fill="#4a7c10"/>
    <path d="M17 22 L18 27 L30 27 L31 22" fill="none" stroke="#4a7c10" strokeWidth="1.5" strokeLinecap="round"/>
    <line x1="16" y1="22" x2="17" y2="22" stroke="#4a7c10" strokeWidth="1.5" strokeLinecap="round"/>
    <circle cx="20" cy="29" r="1" fill="#4a7c10"/>
    <circle cx="28" cy="29" r="1" fill="#4a7c10"/>
    {/* Checkmark */}
    <circle cx="33" cy="14" r="5" fill="#4a7c10"/>
    <path d="M30.5 14 L32.5 16 L35.5 12" fill="none" stroke="#fff" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const VeggieBoxIcon = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
    <rect width="48" height="48" rx="10" fill="#E8F5D4"/>
    {/* Wooden box */}
    <rect x="8" y="30" width="32" height="14" rx="2" fill="#C19A6B"/>
    <rect x="8" y="30" width="32" height="4" rx="2" fill="#A0784A"/>
    <line x1="24" y1="30" x2="24" y2="44" stroke="#A0784A" strokeWidth="1"/>
    {/* Carrot */}
    <path d="M20 28 L18 18 L22 20 Z" fill="#FF6B35"/>
    <path d="M18 18 Q20 14 22 18" fill="#4CAF50"/>
    {/* Tomato */}
    <circle cx="26" cy="24" r="5" fill="#E53E3E"/>
    <path d="M24 19 Q26 16 28 19" fill="#4CAF50" strokeWidth="1"/>
    {/* Leaf top */}
    <path d="M14 22 Q16 16 22 18" fill="none" stroke="#4CAF50" strokeWidth="1.5"/>
    {/* Green */}
    <circle cx="33" cy="22" r="4" fill="#66BB6A"/>
    <circle cx="30" cy="20" r="3" fill="#4CAF50"/>
  </svg>
);

const CookingPotIcon = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
    <rect width="48" height="48" rx="10" fill="#E8F5D4"/>
    {/* Pot body */}
    <rect x="10" y="22" width="28" height="18" rx="3" fill="#2d4a0f"/>
    <rect x="10" y="22" width="28" height="5" rx="3" fill="#1a2e08"/>
    {/* Handles */}
    <rect x="5" y="24" width="6" height="4" rx="2" fill="#4a7c10"/>
    <rect x="37" y="24" width="6" height="4" rx="2" fill="#4a7c10"/>
    {/* Lid */}
    <rect x="12" y="18" width="24" height="5" rx="2" fill="#3d6614"/>
    <rect x="21" y="14" width="6" height="5" rx="2" fill="#4a7c10"/>
    {/* Leaf emblem */}
    <circle cx="24" cy="31" r="5" fill="#4a7c10"/>
    <path d="M21 31 Q24 26 27 31 Q24 34 21 31Z" fill="#7ab83a" opacity="0.7"/>
    {/* Steam */}
    <path d="M17 16 Q19 12 17 8" fill="none" stroke="#a8d87a" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M24 15 Q26 11 24 7" fill="none" stroke="#a8d87a" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M31 16 Q33 12 31 8" fill="none" stroke="#a8d87a" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
  </svg>
);

const DeliveryBoxIcon = () => (
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" width="44" height="44">
    <rect width="48" height="48" rx="10" fill="#E8F5D4"/>
    {/* Box body */}
    <rect x="8" y="18" width="32" height="24" rx="3" fill="#4a7c10"/>
    {/* Box top flaps */}
    <path d="M8 18 L8 14 L24 16 L24 18Z" fill="#3d6614"/>
    <path d="M40 18 L40 14 L24 16 L24 18Z" fill="#5a9620"/>
    {/* Tape/seal line */}
    <rect x="8" y="26" width="32" height="3" fill="#3d6614"/>
    {/* Heart */}
    <path d="M20 33 C20 30 24 28 24 33 C24 28 28 30 28 33 C28 37 24 40 24 40 C24 40 20 37 20 33Z" fill="#fff" opacity="0.9"/>
    {/* Leaf decoration */}
    <circle cx="36" cy="15" r="5" fill="#7ab83a"/>
    <path d="M33 15 Q36 11 39 15 Q36 18 33 15Z" fill="#fff" opacity="0.5"/>
  </svg>
);

const timelineSteps = [
  { img: a1, title: "Your Order",                           desc: "This is when everything begins.",                                     highlight: null },
  { img: a2, title: "Fresh ingredients sourced for every order", desc: "Bought after you order. Used only for your order.", highlight: "Gone by end of day." },
  { img: a3, title: "Cooked from scratch",                  desc: "Fresh ingredients, fresh oil.",                                       highlight: "Nothing is pre-prepared." },
  { img: a4, title: "Delivered fresh to you",               desc: null,                                                                  highlight: null },
];

const PreorderInfoModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="pim-overlay">
      <div className="pim-backdrop" onClick={onClose} />

      <div className="pim-sheet">
        {/* Drag handle */}
        <div className="pim-handle-bar" />

        {/* Close button */}
        <button className="pim-close-btn" onClick={onClose} aria-label="Close">✕</button>

        {/* Title */}
        <p className="pim-title-eyebrow">What you're about to order</p>
        <h2 className="pim-title">CANNOT BE COOKED AND DELIVERED IN 30 MINUTES.</h2>

        {/* ── Red card ── */}
        <div className="pim-compare-card pim-compare-bad">
          <div className="pim-compare-badge pim-badge-bad">
            <span className="pim-badge-x">✕</span>
            <span>RESTAURANT DELIVERY APPS</span>
          </div>
          <div className="pim-bad-body">
            <div className="pim-bag-wrap">
              <img src={bag} alt="" className="w-100 " style={{borderBottomLeftRadius:"16px"}}/>
            </div>
            <div className="pim-bad-points">
              {[
                { emoji:"📦", label:"Your Order",      sub:"Food is already waiting." },
                { emoji:"🍲", label:"Most dishes are ready even before your order", sub:null },
                { emoji:"🥘", label:"Pre-made gravies & masala", sub:null },
                { emoji:"🧊", label:"Leftover ingredients & refrigerated stock", sub:null },
              ].map((pt, i) => (
                <div className="pim-bad-point" key={i}>
                  <div className="pim-bad-icon"><span>{pt.emoji}</span></div>
                  <div>
                    <p className="pim-bad-label">{pt.label}</p>
                    {pt.sub && <p className="pim-bad-sub">{pt.sub}</p>}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Green card ── */}
        <div className="pim-compare-card pim-compare-good">
          <div className="pim-compare-badge pim-badge-good">
            <span className="pim-badge-check">✓</span>
            <span>WITH DAILYDISH</span>
          </div>
          <div className="pim-timeline">
            {timelineSteps.map(({ img, title, desc, highlight }, i) => (
              <div className="pim-tl-step" key={i}>
                <div className="pim-tl-spine">
                  <div className="pim-tl-dot" />
                  {i < timelineSteps.length - 1 && <div className="pim-tl-line" />}
                </div>
                <div className="pim-tl-content">
                  <div className="pim-tl-icon"><img src={img} alt="" width="44" height="44" /></div>
                  <div className="pim-tl-text">
                    <p className="pim-tl-title">{title}</p>
                    {(desc || highlight) && (
                      <p className="pim-tl-desc">
                        {desc}{desc && highlight && " "}{highlight && <span className="pim-tl-highlight">{highlight}</span>}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Freshness banner ── */}
        <div className="pim-fresh-banner">
          {/* Left leaves SVG */}
          <svg className="pim-leaves pim-leaves-left" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <path d="M60 90 Q20 70 10 30 Q30 45 60 90Z" fill="#4a7c10" opacity="0.25"/>
            <path d="M65 80 Q35 55 40 15 Q55 40 65 80Z" fill="#7ab83a" opacity="0.2"/>
            <path d="M55 95 Q15 80 20 45 Q38 62 55 95Z" fill="#4a7c10" opacity="0.15"/>
            <circle cx="12" cy="28" r="3" fill="#c2d98a" opacity="0.4"/>
            <circle cx="22" cy="48" r="2" fill="#c2d98a" opacity="0.3"/>
            <circle cx="40" cy="15" r="2.5" fill="#c2d98a" opacity="0.35"/>
          </svg>
          <div className="pim-fresh-inner">
            {/* <span className="pim-fresh-leaf">🌿</span> */}
            <p className="pim-fresh-tagline">
              <em>DailyDish is optimised for{" "}
                <span className="pim-fresh-accent">freshness</span>, not speed.
              </em>
            </p>
          </div>
          {/* Right leaves SVG */}
          <svg className="pim-leaves pim-leaves-right" viewBox="0 0 80 100" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 90 Q60 70 70 30 Q50 45 20 90Z" fill="#4a7c10" opacity="0.25"/>
            <path d="M15 80 Q45 55 40 15 Q25 40 15 80Z" fill="#7ab83a" opacity="0.2"/>
            <path d="M25 95 Q65 80 60 45 Q42 62 25 95Z" fill="#4a7c10" opacity="0.15"/>
            <circle cx="68" cy="28" r="3" fill="#c2d98a" opacity="0.4"/>
            <circle cx="58" cy="48" r="2" fill="#c2d98a" opacity="0.3"/>
            <circle cx="40" cy="15" r="2.5" fill="#c2d98a" opacity="0.35"/>
          </svg>
        </div>

        {/* Quality strip */}
        <div className="pim-quality-strip">
          <p className="pim-quality-label">Every dish. Every order.</p>
          <p className="pim-quality-badges">✅ No food colours &nbsp;·&nbsp; ✅ No MSG &nbsp;·&nbsp; ✅ Never oily</p>
        </div>

        {/* Closing text */}
        <p className="pim-closing-text">Pre-ordering isn't a wait.</p>

        {/* CTA */}
        <button className="pim-cta-btn" onClick={onClose}>Yes, cook it right for me</button>
      </div>
    </div>
  );
};

export default PreorderInfoModal;